module.exports = __webpack_public_path__ + "img/fundoAllto.d74dcfe7.f68c1142.png";